import React, { Component } from 'react';
import History from "./index";
import ReactTooltip from "react-tooltip";
import {globals} from "../../../../common/constants";

class HistoryWrapper extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isHistoryOpen: false,
            isMobile:  window.innerWidth < globals.NAV_MIDDLE
        };
    }

    toggleHistoryTable = () => {
        this.setState({ isHistoryOpen: !this.state.isHistoryOpen })
    }

    render() {
        return (<div className="history-list">
            <button
                type='button'
                data-for="history-title"
                data-tip="Click here to view the timeline of changes made to this case."
                onClick={this.toggleHistoryTable}
                className='history__btn btn-link'
            >
                <span className="kr kr-history" />
                <span>
                   {this.state.isHistoryOpen ? 'Hide History' : 'View History'}
                </span>
            </button>
            {!this.state.isHistoryOpen && !this.state.isMobile ? <ReactTooltip id="history-title" place="right" type="light" effect="float" /> : null}
            {this.state.isHistoryOpen && <History caseId={this.props.caseId}  />}
        </div> )
    }
}

export default HistoryWrapper;



// WEBPACK FOOTER //
// ./src/components/History/wrapper.js